export default __webpack_public_path__ + "static/about-a56e9747eebd32697af9def0ad56c2cb.svg";